// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"98a52df64e9f51f28478","223":"67c994d5e2d79bb8ab3c","293":"cb110fbede50d3d789e6"}[chunkId] + ".js";
};